/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_OperationInputs */

const en_cargos_operation = /** @type {(inputs: Cargos_OperationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operation`)
};

const es_cargos_operation = /** @type {(inputs: Cargos_OperationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operacion`)
};

/**
* | output |
* | --- |
* | "Operation" |
*
* @param {Cargos_OperationInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_operation = /** @type {((inputs?: Cargos_OperationInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_OperationInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_operation(inputs)
	return es_cargos_operation(inputs)
});